///jacques-andre-editeur\proshop-v2\frontend\src\components\AuthorCard.jsx
import { Link } from 'react-router-dom';
import DOMPurify from 'dompurify';


const AuthorCard = ({ author }) => {

  const name = author.firstName ? author.firstName + " " + author.lastName : author.lastName;

  return (
    <div className='book-card'>
      <Link to={`/auteur/${author.slug}`} className='author-card-link' title={name}>
        <img src={author.photo} variant='top' className='author-card-img' alt={name} title={name}/>  
        <div className='author-card-title'>{name}</div>
          <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(author.bio.slice(0, 200) + '...') }} />
        <p className="enSavoirPlus">
          En savoir plus
        </p>
      </Link>  
    </div>
  );
};

export default AuthorCard;
